import React, { useState, useEffect } from "react";
import styled, { keyframes, css }  from "styled-components";

import Close from "../../images/close_icon.png";
import dialogIcon from "../../images/dialog_icon.png";
import exclamationIcon from "../../images/exclamation_icon.png"


const fadeIn = keyframes`
  from {
    opacity: 0
  }
  to {
    opacity: 1
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1
  }
  to {
    opacity: 0
  }
`;

const slideUp = keyframes`
  from {
    transform: translateY(200px);
  }
  to {
    transform: translateY(0px);
  }
`;

const slideDown = keyframes`
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY(200px);
  }
`;

export const DarkBackground = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);

  animation-duration: 0.25s;
  animation-timing-function: ease-out;
  animation-name: ${fadeIn};
  animation-fill-mode: forwards;
  z-index: 100;

  ${props =>
    props.disappear &&
    css`
      animation-name: ${fadeOut};
    `}
`;

const DialogBlock = styled.div`
  position: absolute;
  width: 450px;
  height: 180px;

  background: #ffffff;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15);
  border-radius: 15px;

  display: table;
  align-items: center;

  animation-duration: 0.25s;
  animation-timing-function: ease-out;
  animation-name: ${slideUp};
  animation-fill-mode: forwards;

  ${props =>
    props.disappear &&
    css`
      animation-name: ${slideDown};
    `}

  p {
    position: absolute;
    left: 106px;
    top: 120px;
    font-family: Sandoll GothicNeo1;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 15px;
    /* identical to box height, or 75% */

    text-align: center;

    color: #000000;
  }
`;

export const ExitButton = styled.img`
  width: 20px;
  height: 20px;

  position: absolute;
  right: 20px;
  top: 20px;
`;
ExitButton.defaultProps = {
  src: Close,
};

const DialogIcon = styled.img`
  width: 60px;
  height: 60px;

  position: absolute;
  top: 30px;
  left: 190px;
`;

const ExclamationIcon = styled.img`
  width:5px;
  height:28px;

  position: absolute;
  top: 45px;
  left: 218px;
`;


function Dialog({ children, onClose, visible, onMaskClick }) {
  const [animate, setAnimate] = useState(false);
  const [localVisible, setLocalVisible] = useState(visible);

  useEffect(() => {
    // visible 값이 true -> false 가 되는 것을 감지
    if (localVisible && !visible) {
      setAnimate(true);
      setTimeout(() => setAnimate(false), 250);
    }
    setLocalVisible(visible);
  }, [localVisible, visible]);


  if (!animate && !localVisible) return null;
  return (
    <DarkBackground disappear={!visible} onClick={onMaskClick}>
      <DialogBlock disappear={!visible}>
        <ExitButton onClick={onClose}/>
        <DialogIcon src={dialogIcon}></DialogIcon>
        <ExclamationIcon src={exclamationIcon}></ExclamationIcon>
        <p>{children}</p>
      </DialogBlock>
    </DarkBackground>
  );
}

Dialog.defaultProps={
    children: '모든 입력사항을 확인해주세요'
};

export default Dialog;


/*

    const [dialog,setDialog] = useState(false);
    const onClick = () => {
        setDialog(true);
    };
    const onClose=()=>{
        setDialog(false)
    }

*/